angular.module('unica_archive_media.archive_media_services')

.factory('ArchiveMediaDeleteService', function ($http, getBaseApiURL) {

	var mediaDeleteService = {};

	mediaDeleteService.delete = function (mediaId) {
		return $http({
			method: 'DELETE',
			url: getBaseApiURL + '/media/delete-archive/' + mediaId,
			data: {	}
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});

	};

	return mediaDeleteService;
});